import React from "react"

type SpacingProps = {
  value: number
}

export const Spacing = ({value}: SpacingProps) => {
  const style: React.CSSProperties = {
    marginTop: `${value}px`,
  }

  return <div style={style}>&nbsp;</div>
}
